import { Typography } from '@material-ui/core';
import styled from 'styled-components';

import { InformPageWrapper } from '@/core/components/InformPageWrapper';

import { colors } from '@/utils/constants';

interface ErrorProps {
  statusCode: number;
}

const Headline = styled.h1`
  width: 100%;
  padding-right: 40px;
  color: ${colors.black};
  font-weight: bold;
  font-size: 48px;
  line-height: 60px;
`;

export const Error = ({ statusCode }: ErrorProps) => {
  if (statusCode === 404) {
    return (
      <InformPageWrapper>
        <Headline>
          404 - Page not found
        </Headline>
        <Typography variant="body1">
          The page you are looking for might have been removed or temporarily unavailable.
        </Typography>
      </InformPageWrapper>
    );
  }

  return (
    <InformPageWrapper>
      <Headline>
        Something went wrong
      </Headline>
      <Typography variant="body1">
        The page you are looking for might have been removed or temporarily unavailable.
      </Typography>
    </InformPageWrapper>
  );
};
